(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    

class CapmessoSlideshowHeight extends HTMLElement {
  connectedCallback() {
    this.frame = 0;
    this.section = this.closest('.shopify-section');
    this.component = this.section?.querySelector('slideshow-component.capmesso-image-fit');
    this.scroller = this.component?.querySelector('slideshow-slides');
    if (!this.scroller) return;
    this.abort = new AbortController();
    const signal = this.abort.signal;
    this.schedule = () => {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.updateHeight());
    };
    this.component.addEventListener('slideshow:select', (event) => {
      if (event.target !== this.component) return;
      this.selected = event.detail?.slide || null;
      this.schedule();
    }, { signal });
    this.section.addEventListener('shopify:block:select', this.schedule, { signal });
    this.component.addEventListener('load', this.schedule, { capture: true, signal });
    this.resize = new ResizeObserver(this.schedule);
    this.resize.observe(this.scroller);
    for (const slide of this.scroller.children) this.resize.observe(slide);
    this.mutations = new MutationObserver(this.schedule);
    this.mutations.observe(this.scroller, {
      subtree: true, attributes: true, attributeFilter: ['aria-hidden', 'hidden']
    });
    this.schedule();
  }

  updateHeight() {
    if (!this.isConnected) return;
    const slides = Array.from(this.scroller.children).filter(
      (node) => node.tagName === 'SLIDESHOW-SLIDE' && !node.hidden
    );
    const index = this.component.current;
    const active = this.selected && slides.includes(this.selected)
      ? this.selected
      : (Number.isInteger(index) && slides[index]) ||
        slides.find((slide) => slide.getAttribute('aria-hidden') === 'false') || slides[0];
    if (!active) return;
    const media = active.querySelector(':scope > [data-capmesso-image-ratio]');
    if (!media) {
      this.component.removeAttribute('data-image-height-ready');
      this.component.style.removeProperty('--capmesso-active-height');
      return;
    }
    let height = media.getBoundingClientRect().height;
    if (this.component.classList.contains('slideshow--content-below-media')) {
      const content = active.querySelector(':scope > .slide__content');
      height += content?.getBoundingClientRect().height || 0;
    }
    if (height <= 0) return;
    const value = `${Math.round(height * 100) / 100}px`;
    if (this.component.style.getPropertyValue('--capmesso-active-height') !== value) {
      this.component.style.setProperty('--capmesso-active-height', value);
    }
    this.component.setAttribute('data-image-height-ready', '');
  }

  disconnectedCallback() {
    cancelAnimationFrame(this.frame);
    this.abort?.abort();
    this.resize?.disconnect();
    this.mutations?.disconnect();
  }
}

if (!customElements.get('capmesso-slideshow-height')) {
  customElements.define('capmesso-slideshow-height', CapmessoSlideshowHeight);
}

  } catch(e) { console.error(e); }
})();
})();
